export const PROMOTIONAL_NAV_CATEGORY = {
  id: "promotional-offers",
  description: "Акційні пропозиції",
  parent: null,
  children: [],
};

export const WHOLESALE_NAV_CATEGORY = {
  id: "wholesale",
  description: "Опт",
  parent: null,
  children: [],
};

const VIRTUAL_NAV_CATEGORY_IDS = new Set([PROMOTIONAL_NAV_CATEGORY.id, WHOLESALE_NAV_CATEGORY.id]);

const VIRTUAL_NAV_CATEGORY_DESCRIPTIONS = new Set([
  PROMOTIONAL_NAV_CATEGORY.description,
  WHOLESALE_NAV_CATEGORY.description,
]);

function isRootVirtualDuplicate(category) {
  if (!category || category.parent !== null) {
    return false;
  }

  return VIRTUAL_NAV_CATEGORY_DESCRIPTIONS.has(category.description);
}

/**
 * Ensures promotional and wholesale virtual items appear once at the top of sidebar navigation.
 */
export function withVirtualNavigationCategories(categories) {
  const list = (categories || []).filter(
    (category) => !VIRTUAL_NAV_CATEGORY_IDS.has(category.id) && !isRootVirtualDuplicate(category)
  );

  return [{ ...WHOLESALE_NAV_CATEGORY }, { ...PROMOTIONAL_NAV_CATEGORY }, ...list];
}
